import "../../styles/main.scss";
import Hero from "../../components/Hero/Hero";
import About from "../../components/About/About";
import Interests from "../../components/Interests/Interests";
import Projects from "../../components/Projects/Projects";
import Passion from "../../components/Passion/Passion";
import CareerPath from "../../components/CareerPath/CareerPath";


const HomePage = () => {
  return (
    <div className="main">
      <Hero />
      <div className="main__space"></div>
      <div className="main__contents">
        <div className="main__wrapper">
          <About />
          <div className="space"></div>
          <Interests />
          <div className="space"></div>
          <CareerPath />
          <div className="space"></div>
          <Passion />
          <div className="space"></div>
          <Projects />
        </div>
      </div>
    </div>
  );
};
export default HomePage;